import React from "react";
import StatusDiv from "../../../../components/molecures/StatusDiv";
import { OrderItemReturnStatuses } from "../../../../shared/enums";

import { theme } from "../../../../theme";

interface Props {
  status: OrderItemReturnStatuses;
}
const ReturnStatusText: React.FC<Props> = ({ status }) => {
  switch (status) {
    case OrderItemReturnStatuses.COMPLETED_RETURN:
      return <StatusDiv isExposed={false}>반품완료</StatusDiv>;
    case OrderItemReturnStatuses.CONFIRMED_RETURN:
      return <StatusDiv isExposed>반품승인</StatusDiv>;
    case OrderItemReturnStatuses.REQUESTED_RETURN:
      return (
        <StatusDiv
          color={theme.colors.red3}
          isExposed={status === OrderItemReturnStatuses.REQUESTED_RETURN}
        >
          반품요청
        </StatusDiv>
      );
    default:
      return <>-</>;
  }
};
export default ReturnStatusText;
